"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressFormInternal = void 0;
var _zod = require("@hookform/resolvers/zod");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _swr = _interopRequireDefault(require("swr"));
var _immutable = _interopRequireDefault(require("swr/immutable"));
var _components = require("../components");
var _constants = require("../constants");
var _hooks = require("../hooks");
var _useTranslations = require("../hooks/useTranslations");
var _models = require("../models");
var _utils = require("../utils");
var _AddressFormBasic = require("./AddressFormBasic");
var _validationSchema = require("./validationSchema");
var _jsxRuntime = require("react/jsx-runtime");
// eslint-disable-next-line import/extensions -- need mjs file extension

const AddressFormInternal = props => {
  const {
    configForm,
    customerId = -1,
    addressId,
    initialCountry,
    handleCallbackData,
    handleCallbackError
  } = props;
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    data: addressMetadata
  } = (0, _swr.default)([customerId], async customerIdProperty => {
    const result = await (0, _hooks.fetchAddressMetadata)(api, customerIdProperty);
    if (result.isSuccess() && result.response) {
      return result.response;
    }
    throw new Error('request failed fetch metadata');
  }, {
    onError(err) {
      if (err) {
        handleCallbackError?.(err);
      }
    }
  });
  const {
    data: localDefaultValues,
    mutate,
    isValidating
  } = (0, _immutable.default)(
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  addressId && customerId ? [customerId, addressId] : null, async () => {
    const addressResponse = await (0, _hooks.fetchAddressList)(api, customerId);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (addressResponse?.status) {
      const result = new _models.FetchResult(addressResponse.status);
      if (result.isSuccess()) {
        const selectedAddress = addressResponse.data.customerAddressesCollection.find(address => address.addressId === addressId);
        if (selectedAddress) {
          return selectedAddress;
        }
      }
    }
    throw new Error('request failed fetch address list data');
  }, {
    revalidateOnMount: true,
    onError(err) {
      if (err) {
        handleCallbackError?.(err);
      }
    }
  });
  const currentDefaultValues = (0, _react.useMemo)(() => localDefaultValues ?? _constants.defaultValues, [localDefaultValues]);
  const [submitErrors, setSubmitErrors] = (0, _react.useState)();
  const [submitModelsErrors, setSubmitModelsErrors] = (0, _react.useState)();
  const submitForm = async data => {
    const availableCountry = addressMetadata?.country?.availableOptions[0] ?? '';
    const updateCountry = addressMetadata?.country?.availableOptions.includes(data.country ?? availableCountry);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    const action = addressId ? 'updateAddress' : 'createAddress';
    const currentData = {
      ...data,
      country: updateCountry ? data.country : availableCountry,
      addressId
    };
    const result = await (0, _hooks.submitAddress)(api, customerId, currentData, action);
    if (action === 'createAddress' && result.isSuccess() && typeof result.response == 'number') {
      handleCallbackData?.({
        ...data,
        addressId: result.response
      });
    } else if (action === 'updateAddress' && result.isSuccess()) {
      mutate({
        ...localDefaultValues,
        ...data,
        addressId
      });
      handleCallbackData?.({
        ...data,
        addressId
      });
    }
    if (!result.isSuccess()) {
      const errors = new _utils.FormErrorBuilder([result.response], data);
      const errorArr = [];
      Object.entries(errors.fieldErrors).forEach(([key, value]) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- needed this condition
        if (value?.message) {
          const error = value.message;
          const errorVal = formatMessage(error.localization);
          errorArr.push({
            key: key,
            value: errorVal
          });
        }
      });
      if (errorArr.length > 0) {
        setSubmitErrors(errorArr);
      }
      if (errors.errorStatus.modelErrors.length > 0) {
        setSubmitModelsErrors(errors.errorStatus.modelErrors);
      }
      handleCallbackError?.(result);
    }
  };
  const isLoading = isValidating || !addressMetadata;
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Loading, {});
  }
  const validationSchema = (0, _validationSchema.generateValidationSchema)(addressMetadata, formatMessage);
  const configProfileAddressForm = {
    ...configForm,
    defaultValues: {
      ...currentDefaultValues,
      isPrimary: configForm.isPrimaryChecked ? true : currentDefaultValues.isPrimary,
      country: initialCountry ?? localDefaultValues?.country
    },
    metadataConfig: addressMetadata,
    onSubmitErrors: submitErrors,
    onSubmitModelsErrors: submitModelsErrors,
    onSubmit: submitForm,
    resolver: (0, _zod.zodResolver)(validationSchema)
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressFormBasic.AddressFormBasic, {
    ...configProfileAddressForm
  });
};
exports.AddressFormInternal = AddressFormInternal;
//# sourceMappingURL=AddressFormInternal.js.map